import React from 'react';

import { Button } from 'components';

import styles from './styles.scss';

export default class MenuItem extends React.PureComponent {
  render() {
    const { icon, children, ...props } = this.props;

    if (this.props.to) {
      <a {...props} className={styles.item}>
        {icon ? icon : null}
        <span>{children}</span>
      </a>;
    }

    return (
      <Button {...props} className={styles.item} fillClass={styles.fill} fill={true} activeClassName={styles.active}>
        {icon ? icon : null}
        <span>{children}</span>
      </Button>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/menu-item/index.js